<template lang="pug">
  div.print-absolute.map-container.geo.map-objects
    page-preloader(:show="preloader")
    div.no-print.toolbar
      .mobile-title
        span.mobile-title__number.semibold 01
        span Территориальная схема
      div.line.toolbar__line
        h1.title.toolbar__title {{$translate(title)}}
    date-slider(
      v-if="hasRegopFilter"
      :style="yearSelectorStyles"
      :mapType='selectedMappingObject'
      @map-update='updateMapByYear'
      :route='$route'
    )
    map-mapping-legend(
      :mappingCurrentLegend="mappingCurrentLegend"
      :legendItems="legendItems"
    )
    map-layer-legend(
      :items="layerLegendItems"
      :layerGroups="layerGroups"
    )
    div.new-map
      div(ref="map" v-once)#map.map.absolute
      transition(name="fade")
        div.no-print.legend.legend--objects.cuscroll(:class="showMapLegend ? 'opened' : 'closed'")
          div(v-if="layersLoading").hover-on-loading
          e-perfect-scrollbar
            div.legend__head(@click="showMapLegend = !showMapLegend")
              button.reset-btn.legend__close(v-if="showMapLegend")
              button.reset-btn.legend__open(v-else)
              h2.legend__title {{$translate('Слои')}}
            mno-map-mapping-selector(
              :mappingConfObject="mappingConfObject"
              :selectedMappingObject="selectedMappingObject"
              @change="setSelectedMappingObject"
              @rosreestrChangeView="onRosreestrChangeView"
            )
            div.legend__group(v-for="(item, name) in mnoLayersConf" :key="name" :class="'legend__group_' + item.iconType")
              div.legend__type
                .custom-checkbox
                  input.visually-hidden.custom-checkbox__input(type="checkbox" @change="onMnoLayersChange(item, name)" v-model="mnoLayers" :value="name"  :id="'checkbox-' + name")
                  label.legend__label.custom-checkbox__label(:for="'checkbox-' + name")
                    span.custom-checkbox__block
                    span.custom-checkbox__text.semibold {{$translate(item.label)}}
              template(v-if="item.groups" v-for="(groupItem, groupItemName) in item.groups")
                div(v-if="groupItem && groupItem.label !== item.label").legend__small-group
                  .custom-checkbox
                    input.visually-hidden.custom-checkbox__input(
                      type="checkbox"
                      :id="'checkbox-' + groupItemName"
                      :value="groupItemName"
                      v-model="mnoLayers"
                      @change="onMnoLayersChange(groupItem, groupItemName, name)"
                    )
                    label.legend__label.custom-checkbox__label(:for="'checkbox-' + groupItemName")
                      span.custom-checkbox__block
                      span.legend-icon(:class="'legend-icon_' + groupItem.iconType")
                      span.custom-checkbox__text {{$translate(groupItem.label)}}
            div.legend__group.legend__group_operator(v-if="hasRegopFilter")
              div.legend__type
                .custom-checkbox
                  input.visually-hidden.custom-checkbox__input(type="checkbox" id="checkbox-zones" @change="onOperatorsChange()" v-model="operatorsCommon" :value="Boolean(operatorsCommon)")
                  label.legend__label.custom-checkbox__label(for="checkbox-zones")
                    span.custom-checkbox__block
                    span.legend__marker
                    span.custom-checkbox__text.semibold Зоны деятельности региональных операторов
              .legend__small-group(v-for="item in apolist" :key="item.id")
                .custom-checkbox
                  input.visually-hidden.custom-checkbox__input(
                    type="checkbox"
                    :value="item.id"
                    :id="'checkbox-zone-' + item.id"
                    @change="updateRegop"
                  )
                  label.legend__label.custom-checkbox__label(:for="'checkbox-zone-' + item.id")
                    span.custom-checkbox__block
                    span.custom-checkbox__text {{item.name}}
    router-view
</template>

<script>
import { REGION_CONFIG } from '@/config/regions'
import { atu } from '@/api/api-endpoints'
import year from '@/utils/year'
import * as L from 'leaflet'
import { COLORS } from '@/utils'
import hasMixin from '@/mixins/has-mixin'
import objectsMixin from './mixins/objects-mixin'
import mappingMixin from './mixins/mapping-mixin'
import mnoMixin from './mixins/mno-mixin'
import MapMappingLegend from './components/map-mapping-legend'
import MnoMapMappingSelector from './components/mno-map-mapping-selector'
import MapLayerLegend from './components/map-layer-legend'
import DateSlider from './components/map-date-slider'
import { statuses } from './config/statuses'
import mapMsnDetailsMixin from './mixins/map-msn-details-mixin'

export default {
  name: 'objects',
  components: {
    MnoMapMappingSelector,
    MapMappingLegend,
    MapLayerLegend,
    DateSlider,
  },
  mixins: [objectsMixin, mappingMixin, mnoMixin, hasMixin, mapMsnDetailsMixin],
  data: () => ({
    operatorsCommon: false,
    operatorsZoneCommon: false,
    year: year.getCurrentYear(),
    statuses,
    operatorLayers: null,
    apolist: [],
    regoplist: [],
    objects: [],
    selectedOperators: [],
    selectedZoneOperators: [],
  }),
  computed: {
    title() {
      return this.$route.meta.title
    },
    preloader() {
      return this.$store.getters.preloader
    },
  },
  methods: {
    updateMapByYear(year) {
      this.year = year
      if (this.operatorsCommon || this.selectedOperators.length) {
        this.onOperatorsChange(this.selectedOperators)
      }
      //дёрнуть обнову года в url
      this.replaceRoute({ year }, false)
      // дёргаем обнову данных на карте ...
      switch (this.selectedMappingObject) {
        case 'formed':
          this.onMappingCurrentLegend()
          break
        case 'zones':
          break
      }
    },
    async getApo() {
      const list = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: atu.apoName(),
        })
      ).data.data
      this.apolist = list.map((item) => {
        item.checked = false
        return item
      })
      list.forEach((zone) => {
        let operator_ = this.regoplist.filter((i) => {
          return i.id == zone.tko_operator_id
        })
        if (operator_.length > 0) {
          operator_[0].zones.push(zone)
        } else {
          this.regoplist.push({
            checked: false,
            id: zone.tko_operator_id,
            name: zone.tkoOperator.name,
            zones: [zone],
          })
        }
      })
    },
    async getObjects() {
      this.objects = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: atu.atuObjectUpdateOrCreate(),
          fromCache: false,
          notReactive: false,
        })
      ).data.data
    },
    updateRegopZone(event) {
      let selectedItem_ = this.regoplist.find(
        (item) => item.id === Number(event.target.value)
      )
      selectedItem_.checked = !selectedItem_.checked
      if (selectedItem_.checked) {
        this.selectedZoneOperators.push(selectedItem_.id)
      } else {
        this.selectedZoneOperators = this.selectedZoneOperators.filter((i) => {
          return selectedItem_.id !== i
        })
      }
      let apoIds = []
      this.selectedZoneOperators.forEach((item) => {
        let item_ = this.regoplist.filter((i) => {
          return i.id === Number(item)
        })[0]
        item_.zones.forEach((z) => {
          apoIds.push(z.id)
        })
      })
      this.onOperatorsZoneChange(apoIds)
    },
    async onOperatorsZoneChange(apoIds = []) {
      if (!apoIds.length && this.operatorsZoneCommon) {
        this.selectedZoneOperators = []
        this.regoplist.forEach((i) => {
          i.checked = !i.checked
          i.zones.forEach((z) => {
            apoIds.push(z.id)
          })
          if (i.checked) {
            this.selectedZoneOperators.push(i.id.toString())
          }
        })
      }
      if (!apoIds.length && !this.operatorsZoneCommon) {
        this.regoplist.forEach((i) => {
          i.checked = !i.checked
        })
        this.selectedZoneOperators = []
      }
      if (this.operatorLayers) {
        this.operatorLayers.clearLayers()
      } else {
        this.operatorLayers = new L.FeatureGroup()
      }
      const query = {
        year: this.year,
      }
      if (!this.operatorsZoneCommon) {
        if (apoIds.length) {
          query.apo_ids = apoIds.join(',')
        } else {
          delete query.apo_ids
          return false
        }
      }
      const response = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: atu.apoGeoObject({ query }),
          fromCache: false,
        })
      ).data.data
      if (this.operatorLayers) {
        this.map.addLayer(this.operatorLayers)
        response.forEach((item) => {
          const geoJson = JSON.parse(item.geo_json)
          const getGeoJson = L.geoJson(geoJson, {
            color: item.color || COLORS.blue,
          })
          this.operatorLayers.addLayer(getGeoJson)
        })
      }
    },
    updateRegop(event) {
      const selectedItem = this.apolist.find(
        (item) => item.id === Number(event.target.value)
      )
      selectedItem.checked = !selectedItem.checked
      if (selectedItem.checked) {
        this.selectedOperators.push(selectedItem.id)
      } else {
        const index = this.selectedOperators.findIndex(
          (item) => item === selectedItem.id
        )
        this.selectedOperators.splice(index, 1)
      }
      this.onOperatorsChange(this.selectedOperators)
    },
    async onOperatorsChange(apoIds = []) {
      if (this.operatorLayers) {
        this.operatorLayers.clearLayers()
      } else {
        this.operatorLayers = new L.FeatureGroup()
      }
      const query = {
        year: this.year,
      }
      if (!this.operatorsCommon) {
        if (apoIds.length) {
          query.apo_ids = apoIds.join(',')
        } else {
          delete query.apo_ids
          return false
        }
      }
      const response = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: atu.apoGeoObject({ query }),
          fromCache: false,
        })
      ).data.data
      if (this.operatorLayers) {
        this.map.addLayer(this.operatorLayers)
        response.forEach((item) => {
          const geoJson = JSON.parse(item.geo_json)
          const getGeoJson = L.geoJson(geoJson, {
            color: item.color || COLORS.blue,
          })
          this.operatorLayers.addLayer(getGeoJson)
        })
      }
    },
  },
  mounted() {
    this.map.on('zoomend', () => {
      if (this.selectedMappingObject == 'formed') {
        this.onMappingCurrentLegend()
      }
    })
    this.map.on('zoomend', () => {
      if (this.selectedMappingObject == 'population') {
        this.onMappingCurrentLegend()
      }
    })
    this.map.on('zoomend', () => {
      if (this.selectedMappingObject == 'recycle') {
        this.onMappingCurrentLegend()
      }
    })
    this.map.on('zoomend', () => {
      if (this.selectedMappingObject == 'tomb') {
        this.onMappingCurrentLegend()
      }
    })
    this.map.on('zoomend', () => {
      if (this.selectedMappingObject == 'regOperatorsZones') {
        this.onMappingCurrentLegend()
      }
    })
    if (REGION_CONFIG.rosreestr_view === 'yandex') {
      this.addYandexTile()
    }
  },
  created() {
    this.getApo()
    this.getObjects()
  },
}
</script>
